export var NAMESPACE = 'ui-shell-core';
//# sourceMappingURL=app.constants.js.map